var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createMuiTheme } from '@material-ui/core/styles';
import { purple, green } from '@material-ui/core/colors';
import { fetchJsonFile, getEnvironmentFromUrl } from "./general-helpers";
// const BASE_URI = "https://[client].blob.core.windows.net/theme-config/[env]/[subdomain]/";
var ENV_PATH = {
    development: "dev",
    localhost: "dev",
    qa: "qa",
    production: "prod",
};
export var THEME_FILE = "theme.json";
export var LAYOUT_FILE = "layout.json";
//Return most selective
export var blobUrl = function (path, subdomain, fileName, environment) {
    var _a;
    if (environment === void 0) { environment = null; }
    var env = (_a = getEnvironmentFromUrl()) !== null && _a !== void 0 ? _a : environment;
    var envPath = ENV_PATH[env.toLowerCase()];
    var url = (subdomain) ?
        path + "/" + envPath + "/" + subdomain + "/" + fileName //subdomain-specific files
        : path + "/" + envPath + "/" + fileName; //Fallback to root.
    return url;
};
//Return subdomain only file or fail
export var blobSubdomainUrl = function (path, subdomain, fileName, environment) {
    var _a;
    if (environment === void 0) { environment = null; }
    if (!subdomain) {
        return null;
    }
    var env = (_a = getEnvironmentFromUrl()) !== null && _a !== void 0 ? _a : environment;
    var envPath = ENV_PATH[env.toLowerCase()];
    var url = path + "/" + envPath + "/" + subdomain + "/" + fileName;
    return url;
};
//===
// Fetches the theme for this school/environment from the blob storage
//
export function fetchBlobAsJson(path, subdomain, file) {
    return __awaiter(this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = blobUrl(path, subdomain, file);
                    return [4 /*yield*/, fetchJsonFile(url)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//===
// Build the theme using the json theme from the blob storage
//could set defaults here... but for now, this is just using gaudy colors so we know if we've missed something
var baseTheme = {
    palette: {
        primary: purple,
        secondary: green,
    },
    overrides: {
        MuiInputBase: {
            root: {
                fontFamily: '"Lato", serif',
                "& input": {
                    "&:-webkit-autofill": {
                        transition: "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
                    },
                    "&:-webkit-autofill:focus": {
                        transition: "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
                    },
                    "&:-webkit-autofill:hover": {
                        transition: "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
                    },
                },
            },
        },
    }
};
//------
// Gets the component-level overrides for the different controls
// eslint-disable-next-line no-unused-vars
// function getSubdomainOverrides(theme){
//   if(!theme.components) return {};
//   const cmp = theme.components;
//   const overrides = {};
//   if(cmp.input){
//     overrides.MuiInputBase = {
//       root: {
//         ...cmp.input
//       }
//     }
//   }
//   if(cmp.typography){
//     overrides.MuiTypography = {
//       root: {
//         ...cmp.typography,
//       }
//     }
//   }
//   return overrides;
// }
function omit(obj, fields) {
    if (!obj)
        return obj;
    var result = Object.fromEntries(Object.entries(obj)
        .filter(function (_a) {
        var k = _a[0];
        return !fields.includes(k);
    }));
    return result;
}
//-------
// Creates theme customizations for the school
function buildSubdomainTheme(theme) {
    return {
        palette: {
            primary: {
                main: theme.styles.page.borderColor, //This is used for the circular progress in the player
            },
            secondary: {
                main: theme.styles.page.color,
            },
            background: {
                default: theme.styles.page.backgroundColor, //This is used by CssBaseline (in app-header) to set the background color
            }
        },
        typography: {
            fontFamily: theme.styles.page.fontFamily,
            fontSize: theme.styles.page.fontSize || 14,
            fontWeight: theme.styles.page.fontWeight || "normal",
        },
        overrides: {
            MuiInputBase: {
                root: {
                    fontFamily: theme.styles.page.fontFamily,
                }
            }
        },
        // TODO: Right now, the reports view is inside a white box, so
        // don't include overrides?
        // overrides: getSubdomainOverrides(theme),   //merge in the control style overrides
        schoolColors: __assign({}, omit(theme.styles.page, ["fontFamily", "fontSize"])),
        strings: theme.strings,
        links: theme.links,
        images: theme.images,
        //convert flags into booleans
        flags: Object.keys(theme.flags || {}).map(function (key) { return theme.flags[key] = Boolean(theme.flags[key]); }),
        styles: theme.styles,
    };
}
//-----------------
// Creates and returns the custom theme for the Portal
export var buildTheme = function (theme) {
    var schoolTheme = buildSubdomainTheme(theme);
    var mergedTheme = __assign(__assign({}, baseTheme), schoolTheme);
    return createMuiTheme(mergedTheme);
};
